/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M4.75 2.25C2.1267 2.25 0 4.3766 0 7v11.6236c0 1.5497 1.8655 2.3347 2.9735 1.2513l8.2765-8.0926V15a.75.75 0 0 0 1.5 0V9.25H7a.75.75 0 0 0 0 1.5h3.1602l-8.2354 8.0524c-.1583.1548-.4248.0426-.4248-.1788V7c0-1.795 1.455-3.25 3.25-3.25h10.5V5c0 1.5188 1.2312 2.75 2.75 2.75h4.5v8.6364c0 1.7949-1.4551 3.25-3.25 3.25H12a.75.75 0 0 0 0 1.5h7.25c2.6234 0 4.75-2.1267 4.75-4.75V7c0-2.6234-2.1266-4.75-4.75-4.75H4.75Zm17.663 4c-.3385-1.4333-1.6262-2.5-3.163-2.5h-2.5V5c0 .6904.5596 1.25 1.25 1.25h4.413Z"
    clipRule="evenodd"
  />,
  'OpenTab'
);
